var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"page",staticClass:"container",attrs:{"id":"index"}},[_c('div',{ref:"bg",staticClass:"bg"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }